import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class IssueProdDetailService extends DatabaseGwService{

  URL_PATH: string = "/issue-prod-details";
}
